"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtentsNavigation = void 0;
var ExtentsNavigation = /** @class */ (function () {
    function ExtentsNavigation(_map, _logger, _textPack, _elementId) {
        var _this = this;
        if (_elementId === void 0) { _elementId = "placeholder-extentsNavigation"; }
        this._map = _map;
        this._logger = _logger;
        this._textPack = _textPack;
        this._elementId = _elementId;
        this._initialised = false;
        this.init = function () {
            if (!_this._initialised) {
                _this._element = $("#" + _this._elementId);
                _this._extents = new Array();
                _this._navigating = false;
                _this._position = -1;
                _this.initHtml();
                _this.setButtonState();
                _this.addHandlers();
                _this._initialised = true;
            }
        };
        this.initHtml = function () {
            _this._btnPrevious = $("\n<div class=\"ol-control\">\t\n\t<button id=\"btnExtentsNavigation-Previous\" type=\"button\" title=\"" + _this._textPack.previousMapExtent + "\" aria-label=\"" + _this._textPack.previousMapExtent + "\">\n\t\t<i class=\"fas fa-chevron-left\"></i>\n\t</button>\n</div>");
            _this._btnNext = $("\n<div class=\"ol-control\">\t\n\t<button id=\"btnExtentsNavigation-Next\" type=\"button\" title=\"" + _this._textPack.nextMapExtent + "\" aria-label=\"" + _this._textPack.nextMapExtent + "\">\n\t\t<i class=\"fas fa-chevron-right\"></i>\n</div>");
            _this._element.append(_this._btnPrevious);
            _this._element.append(_this._btnNext);
        };
        this.addHandlers = function () {
            _this._btnNext.on('click', _this.onBtnNextClick);
            _this._btnPrevious.on('click', _this.onBtnPreviousClick);
            _this._map.olMap.on('moveend', _this.onMapMoveEnd);
        };
        this.onBtnNextClick = function (e) {
            if (_this._extents.length === 0) {
                //no extents, add current one
                _this.addExtent(_this._map.olMap);
            }
            //this._logger.log(`ExtentsNavigation onBtnNextClick: position=${this._position}, length=${this._extents.length}`);
            if (_this._position > 0) {
                _this._position -= 1;
                _this.moveMapToExtent(_this._extents[_this._position]);
            }
            _this.setButtonState();
        };
        this.onBtnPreviousClick = function (e) {
            if (_this._extents.length === 0) {
                //no extents, add current one
                _this.addExtent(_this._map.olMap);
            }
            //this._logger.log(`ExtentsNavigation onBtnPreviousClick: position=${this._position}, length=${this._extents.length}`);
            if (_this._position + 1 < _this._extents.length) {
                _this._position += 1;
                _this.moveMapToExtent(_this._extents[_this._position]);
            }
            _this.setButtonState();
        };
        this.onMapMoveEnd = function (e) {
            if (_this._position === -1 && _this._extents.length === 0) {
                //first time in, set position to 0
                _this._position = 0;
            }
            _this.addExtent(e.map);
        };
        this.addExtent = function (map) {
            if (_this._navigating === false) {
                //insert at current position 
                _this._extents.splice(_this._position, 0, {
                    centre: map.getView().getCenter(),
                    zoom: map.getView().getZoom()
                });
                _this.setButtonState();
                //this._logger.log(`ExtentsNavigation addExtent: position=${this._position}, length=${this._extents.length}`);
            }
            else {
                _this._navigating = false;
            }
        };
        this.moveMapToExtent = function (e) {
            _this._navigating = true;
            _this._map.olMap.getView().setCenter(e.centre);
            _this._map.olMap.getView().setZoom(e.zoom);
        };
        this.setButtonState = function () {
            //this._logger.log(`ExtentsNavigation setButtonState: position=${this._position}`);
            if (_this._position > 0) {
                _this._btnNext.removeClass("disabled");
            }
            else {
                _this._btnNext.addClass("disabled");
            }
            if (_this._position + 1 < _this._extents.length) {
                _this._btnPrevious.removeClass("disabled");
            }
            else {
                _this._btnPrevious.addClass("disabled");
            }
        };
        this.init();
    }
    return ExtentsNavigation;
}());
exports.ExtentsNavigation = ExtentsNavigation;
//# sourceMappingURL=ExtentsNavigation.js.map